export default "__VITE_ASSET__vJ9LuOh9__"